export default __webpack_public_path__ + "static/media/file_excel.cad912cc.svg";